import { ICommonIconProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * Renders a package with a `return-arrow` to mean that it's been returned.
 */
export function PackageReturnedIcon({ className }: ICommonIconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <g id="package-returned-icon">
        <path d="M13 21H5.25C4 21 3 20 3 18.75V8.14c0-.3.06-.6.18-.88l1.24-2.89A2.22 2.22 0 0 1 6.48 3h11.03c.9 0 1.72.54 2.07 1.37l1.24 2.89c.12.27.18.57.18.88V12m-9-9v5m-5 9h2" />

        <path d="M21 13v-3a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v7m14 4h1.5a2.5 2.5 0 0 0 2.5-2.5h0a2.5 2.5 0 0 0-2.5-2.5H14" />

        <path d="m16 18-2-2 2-2" />
      </g>
    </svg>
  );
}
